


















/* Created- 02 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ContentStreamBillingConfigurationForm from "@/Ui-Components/ContentStream/ContentStreamBillingConfigurationForm.vue";
import { ContentStreamBillingConfigurationDTO, IContentStreamBillingConfigurationDTO, IContentStreamBillingConfigurationClient } from "../../Generated/ParticaAPI";
import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
@Component(
	{
		name: "ContentStreamBillingConfiguration",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ContentStreamBillingConfigurationForm,
			ParticaCard,
			ParticaView
		}
	})
export default class ContentStreamBillingConfiguration extends ParticaStreamBase {
	private data: ContentStreamBillingConfigurationDTO = new ContentStreamBillingConfigurationDTO();
	private contentStreamService: IContentStreamService;
	@Prop() private id: number;

	private buttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.CONTENT_STREAM_SAVE_BILLING_CONFIG, type: ButtonType.OK } as ButtonConfig,
	] as ButtonConfig[];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_SAVE_BILLING_CONFIG: {
					this.data.contentStreamId = this.id;
					this.data = await this.contentStreamService.saveContentStreamBillingConfig(this.data);
					this.ShowSnackbar("Stream billing configuration saved.");
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Billing Setup";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getStreamNav(this.id);
			this.contentStreamService = this.particaServices.getContentStreamService();
			const result: any = await this.contentStreamService.getContentStreamBillingConfig(this.id);
			if (result && result.id > 0) {
				this.data = result;
			} else {
				this.data = new ContentStreamBillingConfigurationDTO({
					id: 0, contentStreamId: this.id, ownerPercentageContentCharge: 40
				} as IContentStreamBillingConfigurationDTO);
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
